import { __assign } from 'tslib';
import React__default, { useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import clsx from 'clsx';
import { DEFAULT_MODIFIERS, propTypes, defaultProps, VARIANT_MAP } from './Popover.types.js';
import styles from './Popover.module.scss.js';

var Popover = function (props) {
    var className = props.className, children = props.children, variant = props.variant, showArrow = props.showArrow, portalTarget = props.portalTarget, trigger = props.trigger, isOpen = props.isOpen;
    var _a = useState(null), referenceElement = _a[0], setReferenceElement = _a[1];
    var _b = useState(null), popperElement = _b[0], setPopperElement = _b[1];
    var placementName = VARIANT_MAP[variant];
    var _c = usePopper(referenceElement, popperElement, {
        modifiers: DEFAULT_MODIFIERS,
        placement: placementName,
    }), popperStyles = _c.styles, attributes = _c.attributes;
    var renderContent = function () {
        var popoverClasses = clsx(styles.PopoverContent, isOpen && styles.PopoverContent___visible, showArrow && styles.PopoverContent___withArrow, className);
        return (React__default.createElement("div", __assign({ className: popoverClasses, ref: setPopperElement, style: popperStyles.popper, "data-variant": variant, "data-testid": props['data-testid'] }, attributes.popper, { "data-popper-placement": "".concat(placementName) }), children));
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { ref: setReferenceElement, "data-testid": "".concat(props['data-testid'], "-trigger") }, trigger),
        isOpen
            ? portalTarget
                ? createPortal(renderContent(), portalTarget)
                : renderContent()
            : null));
};
Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
Popover.displayName = 'Popover';

export { Popover, Popover as default };
